<div class="selection-backdrop" (click)="onCancel()">

    <div
        class="selection-modal"
        role="dialog"
        aria-modal="true"
        (click)="$event.stopPropagation()">

        <div class="selection-header">

            <h3 class="selection-title">
                {{ header }}
            </h3>

            <button
                type="button"
                class="selection-close"
                aria-label="Fermer"
                (click)="onCancel()">
                ×
            </button>

        </div>


        <div class="selection-body">

            <p
                class="selection-message"
                *ngIf="message">
                {{ message }}
            </p>

            <div class="selection-list">

                <label
                    class="selection-item"
                    [class.selected]="isSelected(item)"
                    *ngFor="let item of items">

                    <input
                        type="checkbox"
                        class="selection-checkbox"
                        [checked]="isSelected(item)"
                        (change)="toggle(item)">

                    <span class="selection-checkbox-display">

                        <span
                            class="selection-check"
                            *ngIf="isSelected(item)">
                            ✓
                        </span>

                    </span>

                    <span class="selection-label">
                        {{ item.label }}
                    </span>

                </label>

            </div>

        </div>


        <div class="selection-footer">

            <button
                type="button"
                class="selection-button selection-button-secondary"
                (click)="onCancel()">

                Annuler

            </button>

            <button
                type="button"
                class="selection-button selection-button-primary"
                [disabled]="selectedIds.size === 0"
                (click)="onValidate()">

                Valider
                <span *ngIf="selectedIds.size > 0">
                    ({{ selectedIds.size }})
                </span>

            </button>

        </div>

    </div>

</div>
